module.exports = __webpack_public_path__ + "img/security2.9c1e477.png";